import { IJobMarketInfo } from '../interfaces/ijob-market-info';

export class JobMarketInfo implements IJobMarketInfo {
    public get DefaultJobBoardIds(): Promise<any[]> {
        return Promise.resolve([
            "DefaultJobBoard1-351f58b5-3394-87bd-1e72-3bc51af1a775"
        ]);
    };
}
